import { Injectable } from '@angular/core';
import { CardTypes } from '@shared/enums/auth.enums';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserTypeService {

  constructor(private authService: AuthService) {
  }

  get user() {
    return this.authService.user;
  }

  get userIsPrivatePerson() {
    return this.user.type === 'private';
  }

  isLoyaltyRozniza(): boolean {
    return this.user.loyaltyCardType && this.user.loyaltyCardType === CardTypes.ROZNIZA;
  }

  get userIsOrganization() {
    return this.user.type === 'org';
  }
}
